import React, { useEffect } from "react";
import { Select, ConfigProvider } from "antd";
import SC from "./style";
import zIndex from "@mui/material/styles/zIndex";
import InnoIcons from "@InnoIcons/";
const { Option } = Select;

const DistributionDropdownWithSearch = (props) => {
  const {
    defaultValue,
    placeholder,
    options,
    onChange,
    onAddNew,
    optionFilterProp = "children",
    width = "340px",
    height = "29px",
    newItemLabel = "+ Add New",
    disabled = false,
    theme = { colors: { bordertask: "#ccc" } },
    dropdowType = "",
    disabledDropdown = false,
    handleRemove = () => {},
  } = props;

  // Ensure the selected value is valid, otherwise reset it to null

  return (
    <ConfigProvider
              theme={{
          token: {
            colorPrimary: "#E36E00", // Updated to new theme color
            colorBorder: theme.colors.bordertask, // Dynamic border color
            colorText: "#374151", // Better text color
            colorTextPlaceholder: "rgba(55, 65, 81, 0.6)", // Better placeholder color
            borderRadius: 8, // Modern border radius
            controlHeight: 40, // Consistent height
          },
        }}
    >
      {SC.Globalstyles}
      <Select
        labelInValue
        showSearch
        value={options.find((opt) => opt.id === defaultValue) || null} // Ensure only the label is shown
        disabled={disabledDropdown}
        onChange={(value) => onChange(value.value)} // Extract only the ID
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        className="custom-select"
        style={{
          width: width,
          height: height,
          textAlign: "left",
          cursor: "pointer",
        }}
        placeholder={placeholder}
        required
        optionFilterProp={optionFilterProp}
        filterOption={(input, option) => {
          const childrenText = React.Children.toArray(option?.children || [])
            .map((child) => child)
            .join("");
          return childrenText.toLowerCase().includes(input.toLowerCase());
        }}
        dropdownRender={(menu) => (
          <>
            {newItemLabel && !disabled && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <span
                  onClick={onAddNew}
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    padding: "8px 12px",
                    color: "#E36E00",
                    fontWeight: "500",
                    transition: "all 0.2s ease",
                    borderRadius: "4px",
                    margin: "4px 8px",
                  }}
                >
                  {newItemLabel}
                </span>
              </div>
            )}
            {menu}
          </>
        )}
      >
        {options &&
          options.length > 0 &&
          options.map((option) => (
            <Option
              key={`${option.id}-${dropdowType}`}
              value={option.id}
              label={option.label} // Ensures only the label is shown in the selected value
              style={{
                borderTop: `1px solid ${theme.colors.bordertask}`,
                borderRadius: "0px",
                cursor: "pointer",
              }}
              title={option.label}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{option.label}</span>
                <InnoIcons.DeleteIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemove(option.id);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: "#ED850C",
                    fontSize: "18px",
                  }}
                />
              </div>
            </Option>
          ))}
      </Select>
    </ConfigProvider>
  );
};

export default DistributionDropdownWithSearch;
